import React, { FC, useEffect, useState } from 'react';

import s from './DesktopApp.scss';

import * as BIManager from '../../utils/bi';
import { fedopsLogger } from '../../utils/fedops-logger';
import { initDealer } from '../../utils/initDealer';

import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { TemplateDemo } from '../TemplateDemo/TemplateDemo';
import { ToolBar } from '../ToolBar/ToolBar';
import { WixStudioToolBar as WixStudioNewToolBar } from '../partials/WixStudioNewToolBar/WixStudioToolBar';
import { WixStudioTemplateDemo } from '../WixStudioTemplateDemo/WixStudioTemplateDemo';

import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { useConfigContext } from '../../context/ConfigContext/ConfigContext';
import { desktopAppDataHooks } from './DesktopApp.dataHooks';
import { TemplateModal } from '../TemplateModal';
import { useUserData } from '../../context/UserDataContext/UserDataContext';
import { useExperimentContext } from '../../context/ExperimentContext/ExperimentContext';

export const DesktopApp: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { viewMode, toggleViewMode, isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { lang, dealerCmsTranslationsUrl, dealerLightboxUrl } = useConfigContext();
  const { editorSessionId, siteId, metaSiteId, isStudio, desktopImage, desktop16X9Image } = template;
  const { activeExperiments } = useExperimentContext();
  const userData = useUserData();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isModalShown = !!Number(globalThis?.window?.localStorage?.getItem?.('newEditModal'));
  const isNewModalAvailable = activeExperiments.includes('newEditModal');
  const isWixelDashboard =
    new URLSearchParams(globalThis?.window?.location?.search).get('sourceContext') === 'wixelDashboard';

  useEffect(() => {
    if (!isOpen && !isModalShown && isNewModalAvailable && !isWixelDashboard) {
      globalThis?.window?.localStorage?.setItem?.('newEditModal', '1');
      setTimeout(() => setIsOpen(true), userData.isLoggedIn ? 1000 : 8000);
    }
  }, [isModalShown, isNewModalAvailable, isOpen, isWixelDashboard, userData.isLoggedIn]);

  useEffect(() => {
    BIManager.reportLoadSuccess();
    fedopsLogger.appLoaded();
    if (isStudio || isNewModalAvailable) {
      return;
    }
    initDealer({
      editorSessionId,
      metaSiteId,
      siteId,
      lang,
      dealerCmsTranslationsUrl,
      dealerLightboxUrl,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.getElementsByTagName('body')[0].classList.toggle('popup', isInfoShown);
  }, [isInfoShown]);

  return (
    <div data-hook={dataHook}>
      {isStudio ? (
        <div className={s.studioRoot}>
          <WixStudioNewToolBar
            viewMode={viewMode}
            toggleViewMode={toggleViewMode}
            dataHook={desktopAppDataHooks.wixStudioNewToolbar}
          />
          <WixStudioTemplateDemo viewMode={viewMode} dataHook={desktopAppDataHooks.wixStudioTemplateDemo} />
        </div>
      ) : (
        <>
          <ToolBar dataHook={desktopAppDataHooks.toolBar} />
          <TemplateDemo dataHook={desktopAppDataHooks.templateDemo} />
          <InfoPopUp dataHook={desktopAppDataHooks.infoPopUp} />
        </>
      )}
      {isOpen && (
        <TemplateModal
          editorUrl={template.editorUrl}
          isOpen
          image={desktop16X9Image || desktopImage}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};
